import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';

import { candidateApprovalMessageQueryKeys } from './queryKeys';

interface CandidateApprovalMessageParams {
  jobId: string;
  candidateId: string;
}

/**
 * The approval message the candidate would be sent if approved now, with its
 * sender, or why none would be sent.
 */
export const useCandidateApprovalMessageQuery = ({
  jobId,
  candidateId,
}: CandidateApprovalMessageParams) =>
  useQuery({
    queryKey: candidateApprovalMessageQueryKeys.detail(jobId, candidateId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(
        candidateEndpoints.approvalMessage,
        { params: { path: { jobId, candidateId } } },
      );

      return data ?? null;
    },
  });
